import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=a5f40034&scoped=true&"
import script from "./BaseTable.vue?vue&type=script&lang=ts&"
export * from "./BaseTable.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=a5f40034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f40034",
  null
  
)

export default component.exports